import { create } from "zustand";
import { addAssignee, getResolveApi, updateAssignee, deleteAssignee } from "../api_layer/api";
import { TOAST_MESSAGE_CSS } from "modules/utilities/utility";

const useBulkAssigneeStore = create((set, get) => ({
  resolveAssigneeData: [],
  addAssigneeLoading: false,
  deleteAssigneeLoading: false,
  resolveAssigneeLoading: false,
  postLoading: false,
  error: null,
  currentPage: 1,
  totalPages: 1,
  searchQuery: '',
  addAssigneeData: async (payload, toast) => {
    try {
      set({ addAssigneeLoading: true, error: null });
      const response = await addAssignee(payload);
      set({ addAssigneeLoading: false });
      toast.success('Assignee added Successfully', TOAST_MESSAGE_CSS);
      get().getResolveAssigneeData();
    } catch (error) {
      set({ error: error.message, addAssigneeLoading: false });
      toast.error('Error in Assignment', TOAST_MESSAGE_CSS);
    }
  },
  updateAssigneeData: async (payload, toast) => {
    try {
      set({ deleteAssigneeLoading: true, error: null });
      await updateAssignee(payload);
      set({ deleteAssigneeLoading: false });
      get().getResolveAssigneeData();
      toast.success("Assignee Updated successfully", TOAST_MESSAGE_CSS);
    } catch (error) {
      set({ error: error.message, deleteAssigneeLoading: false });
      toast.error('Error in Updating Assignee', TOAST_MESSAGE_CSS);
    }
  },
  deleteAssigneeData: async (userId, toast) => { 
    try {
      set({ deleteAssigneeLoading: true, error: null });
      await deleteAssignee({ userId }); 
      set({ deleteAssigneeLoading: false });
      get().getResolveAssigneeData(); 
      toast.success("Assignee Deleted successfully", TOAST_MESSAGE_CSS);
    } catch (error) {
      set({ error: error.message, deleteAssigneeLoading: false });
      toast.error('Error in Deleting Assignee', TOAST_MESSAGE_CSS);
    }
  },
  getResolveAssigneeData: async (page = 1, limit = 10, search = '') => {
    try {
      set({ resolveAssigneeLoading: true, error: null });
      const response = await getResolveApi(page, limit, search);
      set({
        resolveAssigneeData: response.data.assignees,
        resolveAssigneeLoading: false,
        currentPage: response.data.page,
        totalPages: response.data.pages,
        searchQuery: search,
      });
    } catch (error) {
      set({ error: error.message, resolveAssigneeLoading: false });
    }
  },
}));

export default useBulkAssigneeStore;
